module.exports = __webpack_public_path__ + "img/12_college.d5db06c3.png";